<div
  class="main-div content-w-98"
  *ngrxLet="projectFacade.dataAnalysisTechnology$ as dataAnalysisTechnology"
  [piqetAngularSectionAccess]="FeatureCodes.REPORTS_INTERPRETATION_SECTION"
>
  <div class="title-div">
    <div class="headerName">
      <span>Project reporting</span>
    </div>

    <div class="subTitleName">
      <span
        joyrideStep="adv-1"
        stepPosition="right"
        class="w-fit-content"
        text="Welcome to the 'Interpretation' tab. This is an optional stage for advanced reporting.
      Complete all the fields to comply with the ISO 14044 standards.
      For tips on how to draft an ISO 14044 compliant report, go to 'Help' > 'Other resources'."
        >Interpretation</span
      >
    </div>
  </div>

  <div>
    <form [formGroup]="reportChartForm" [ngClass]="{ 'disabled-popup': !showEdit }">
      <div class="row scenarios-div">
        <div class="col-12 d-flex">
          <p class="note-div gray-font">Interpretation fields for advanced reporting</p>
          <span
            placement="auto"
            class="interpretation-tooltip"
            tooltipClass="sku-tooltip"
            ngbTooltip="Fields are not mandatory but are required for those seeking compliance with ISO14044  standards."
          >
            <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
          /></span>
        </div>
      </div>

      <div class="form-group">
        <label class="sub-header-drpdown pb-2">Introduction to ISO 14044 report</label>
        <div class="services-form">
          <textarea
            formControlName="introductionToISOReport"
            class="resizable-textarea"
            cols="20"
            id="Description"
            name="Description"
            rows="2"
            placeholder="Introduction to ISO 14044 report"
            (change)="autoSave(dataAnalysisTechnology)"
          ></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group">
          <label
            class="sub-header-drpdown pb-2"
            joyrideStep="adv-2"
            stepPosition="right"
            text="Here is where you specify the reason for the study."
          >
            Goal and scope</label
          >
          <span
            placement="auto"
            class="textarea-tooltip"
            tooltipClass="sku-tooltip"
            ngbTooltip="Specify the reason for the study and the intended audience."
          >
            <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
          /></span>
          <div class="services-form">
            <textarea
              class="resizable-textarea"
              formControlName="goalAndScope"
              cols="20"
              id="goalAndScope"
              name="goalAndScope"
              rows="2"
              placeholder="Goal and scope"
              (change)="autoSave(dataAnalysisTechnology)"
            ></textarea>
          </div>
        </div>

        <div class="form-group">
          <label
            class="sub-header-drpdown pb-2"
            joyrideStep="adv-3"
            stepPosition="top"
            text="The impact categories should reflect a comprehensive set of indicators which are consistent with the goal and scope."
            >Impact category justification</label
          >
          <span
            placement="auto"
            class="textarea-tooltip"
            tooltipClass="sku-tooltip"
            ngbTooltip="The impact categories should reflect a comprehensive set of indicators which are consistent with the goal and scope.
            The select indicators should prioritise environmentally relevant category indicators, and their relevance should be clearly stated."
          >
            <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
          /></span>
          <div class="services-form">
            <textarea
              class="resizable-textarea"
              formControlName="impactCategoryJustification"
              cols="20"
              id="impactCategoryJustification"
              name="impactCategoryJustification"
              rows="2"
              (change)="autoSave(dataAnalysisTechnology)"
              placeholder="Impact category  justification"
            ></textarea>
          </div>
        </div>

        <div class="form-group">
          <label
            class="sub-header-drpdown pb-2"
            joyrideStep="adv-4"
            stepPosition="top"
            (next)="onNext('adv-4')"
            text="List all value choices, assumptions or limitations that could substantially affect any of the impact category results here."
            >Other assumptions/limitations</label
          >
          <span
            placement="auto"
            class="textarea-tooltip"
            tooltipClass="sku-tooltip"
            ngbTooltip="List all value choices, assumptions or limitations that have
            the potential to substantially affect any of the impact category results here."
          >
            <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
          /></span>
          <div class="services-form">
            <textarea
              formControlName="otherAssumption"
              class="resizable-textarea"
              (change)="autoSave(dataAnalysisTechnology)"
              cols="20"
              id="otherAssumption"
              name="otherAssumption"
              rows="2"
              placeholder="Other assumptions/limitations"
            ></textarea>
          </div>
        </div>
      </div>

      <div formGroupName="ISOReportForm">
        <div class="row scenarios-div ng-select-div reportGenerationDrd">
          <div class="col-12">
            <label class="sub-header-drpdown pb-2">Authors</label>

            <ng-select
              #authorsSelect
              formControlName="authors"
              [items]="
                (authorList || []).length > 0
                  ? authorList
                  : [{ displayValue: 'No authors available', userId: null, disabled: true }]
              "
              bindLabel="displayValue"
              bindValue="userId"
              [multiple]="true"
              [clearable]="true"
              [clearOnBackspace]="false"
              [closeOnSelect]="false"
              [hideSelected]="false"
              [virtualScroll]="true"
              [loading]="isLoadingAuthors"
              placeholder="Select author(s)"
              loadingText="Loading authors..."
              notFoundText="No authors found"
              [typeahead]="searchSubject"
              (scrollToEnd)="onAuthorScrollToEnd()"
              (search)="onAuthorSearch($event)"
              (change)="autoSave(dataAnalysisTechnology)"
              (clear)="clearAuthorSearch()"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback search-header">
                  <input
                    #searchInput
                    type="text"
                    class="form-control search-input"
                    placeholder="Search authors..."
                    [value]="authorSearchTerm"
                    (input)="onAuthorSearchInput($event)"
                    (keydown.enter)="$event.preventDefault()"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon" *ngIf="!isLoadingAuthors"></i>
                    <i class="fa fa-spinner fa-spin icon" *ngIf="isLoadingAuthors"></i>
                  </span>
                  <button
                    type="button"
                    class="btn btn-sm btn-clear"
                    *ngIf="authorSearchTerm"
                    (click)="clearAuthorSearch(); searchInput.focus()"
                    title="Clear search"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </ng-template>

              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div class="author-option" [title]="item?.displayValue">
                  <span class="author-name" [ngOptionHighlight]="authorSearchTerm">
                    {{ item.displayValue }}
                  </span>
                </div>
              </ng-template>

              <ng-template ng-loading-tmp>
                <div class="loading-more">
                  <i class="fa fa-spinner fa-spin"></i>
                  Loading more authors...
                </div>
              </ng-template>

              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="not-found-message">
                  <i class="fa fa-search"></i>
                  <p>No authors found for "{{ searchTerm }}"</p>
                  <small class="text-muted">Try adjusting your search terms</small>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="row scenarios-div ng-select-div reportGenerationDrd">
          <div class="col-12">
            <label
              class="sub-header-drpdown pb-2"
              text="Select whether the study is for internal or external purposes."
              joyrideStep="adv-5"
              (next)="onNext('adv-5')"
              stepPosition="right"
              >Reason for the study</label
            >
            <span
              class="textarea-tooltip"
              placement="auto"
              tooltipClass="sku-tooltip"
              ngbTooltip="State the intended application of the LCA."
            >
              <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
            /></span>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #reasonStudy
              formControlName="reasonOfStudy"
              [items]="lstReasonForStudy"
              [searchable]="false"
              bindLabel="description"
              [searchFn]="commonInputSearchDes"
              [multiple]="false"
              bindValue="id"
              placeholder="Reason for the study"
              (change)="autoSave(dataAnalysisTechnology)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    (input)="reasonStudy.filter($any($event.target).value)"
                    type="text"
                    class="form-control search-input"
                    id="inputValidation"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item.description }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="row scenarios-div ng-select-div" id="critical-sect">
          <div class="col-12 col-md-12 reportGenerationDrd">
            <label
              *ngIf="
                reportChartForm.get('ISOReportForm')?.get('criticalViewer')?.value ||
                reportChartForm.get('ISOReportForm')?.get('organizationISO')?.value
              "
              class="sub-header-drpdown pb-2"
              >Critical reviewer</label
            >
            <ng-select
              [clearable]="true"
              joyrideStep="adv-6"
              stepPosition="top"
              text="Select from our list of critical reviewers who have independently assessed PIQET."
              [clearOnBackspace]="false"
              (next)="onNext('adv-6')"
              #criticalViewer
              formControlName="criticalViewer"
              [items]="lstReviewer"
              [searchable]="false"
              bindLabel="name"
              bindValue="idLong"
              [searchFn]="commonInputSearchName"
              [multiple]="true"
              placeholder="Critical reviewer"
              (change)="autoSave(dataAnalysisTechnology)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    (input)="criticalViewer.filter($any($event.target).value)"
                    type="text"
                    class="form-control search-input"
                    id="inputValidation"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>

          <!-- organizationDetails -->
          <!-- <div class="col-12 col-md-6 reportGenerationDrd">
            <label
              *ngIf="
                reportChartForm.get('ISOReportForm')?.get('criticalViewer')?.value ||
                reportChartForm.get('ISOReportForm')?.get('organizationISO')?.value
              "
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <div class="services-form">
              <input
                formControlName="organizationISO"
                class="no-label-input"
                type="text"
                placeholder="Organization"
              />
            </div>
          </div> -->
        </div>

        <div class="row scenarios-div ng-select-div reportGenerationDrd">
          <div class="col-12 col-md-6">
            <label
              *ngIf="reportChartForm.get('ISOReportForm')?.get('viewSysBoundry')?.value"
              class="sub-header-drpdown pb-2"
              >View system boundary examples</label
            >
            <ng-select
              joyrideStep="adv-7"
              stepPosition="right"
              text="View our system boundary examples and upload your own version for inclusion."
              [clearable]="true"
              [clearOnBackspace]="false"
              #sysBoudary
              formControlName="viewSysBoundry"
              (next)="onNext('adv-7')"
              [items]="systemBoundaryExamples"
              [searchable]="false"
              bindLabel="name"
              [searchFn]="commonInputSearchName"
              [multiple]="false"
              bindValue="id"
              placeholder="View system boundary examples"
              (change)="autoSave(dataAnalysisTechnology)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    (input)="sysBoudary.filter($any($event.target).value)"
                    type="text"
                    class="form-control search-input"
                    id="inputValidation"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div class="w-100 pad-r-40" [ngOptionHighlight]="search" title="{{ item?.name }}">
                  <div class="d-flex justify-content-between">
                    <div>{{ item?.name }}</div>
                    <div class="imageDownloadBtn" (click)="downloadPreviewImage($event, item)">
                      Download
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div class="col-12 col-md-6 reportGenerationDrd" id="sys-boundary">
            <label
              *ngIf="reportChartForm.get('ISOReportForm')?.get('viewSysBoundry')?.value"
              class="sub-header-drpdown pb-2"
              >&nbsp;</label
            >
            <piqet-angular-file-upload
              #systemBoundaryUpload
              type="image"
              [customConfig]="systemBoundaryUploadConfig"
              [existingFileUrl]="imageUrl"
              [existingFileName]="selectedFileName"
              [isDisabled]="!showEdit"
              [isImageValid]="isImageValid && !isImageSizeExceeds"
              (fileSelected)="onSystemBoundaryFileSelected($event)"
              (removeConfirmation)="onSystemBoundaryFileRemoved()"
              [customClass]="'col-sm-12'"
            ></piqet-angular-file-upload>
          </div>
        </div>

        <div class="row">
          <div class="form-group">
            <label
              class="sub-header-drpdown pb-2"
              joyrideStep="adv-8"
              stepPosition="right"
              (next)="onNext('adv-8')"
              text="Provide rationale for your system boundary choices."
              >System boundary justification</label
            >
            <span
              placement="auto"
              class="textarea-tooltip"
              tooltipClass="sku-tooltip"
              ngbTooltip="Provide rationale for your system boundary choices."
            >
              <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
            /></span>
            <div class="services-form">
              <textarea
                formControlName="boundryJustification"
                class="resizable-textarea"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                placeholder="System boundary justification"
                (change)="autoSave(dataAnalysisTechnology)"
              ></textarea>
            </div>
          </div>

          <div class="form-group">
            <label class="sub-header-drpdown pb-2">Geographical boundary justification</label>
            <div class="services-form">
              <textarea
                formControlName="geographicalBoundary"
                class="resizable-textarea"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                placeholder="Geographical boundary"
                (change)="autoSave(dataAnalysisTechnology)"
              ></textarea>
            </div>
          </div>

          <div class="form-group">
            <label class="sub-header-drpdown pb-2">Temporal boundary justification</label>
            <div class="services-form">
              <textarea
                formControlName="temporalBoundary"
                class="resizable-textarea"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                placeholder="Temporal boundary"
                (change)="autoSave(dataAnalysisTechnology)"
              ></textarea>
            </div>
          </div>

          <div class="form-group">
            <label class="sub-header-drpdown pb-2"
              >Approach to biogenic carbon accounting description</label
            >
            <div class="services-form">
              <textarea
                formControlName="biogenicCarbonAccounting"
                class="resizable-textarea"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                placeholder="Approach to biogenic carbon accounting description"
                (change)="autoSave(dataAnalysisTechnology)"
              ></textarea>
            </div>
          </div>

          <div class="form-group">
            <label class="sub-header-drpdown pb-2">Uncertainty analysis description</label>
            <div class="services-form">
              <textarea
                formControlName="uncertaintyAnalysis"
                class="resizable-textarea"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                placeholder="Uncertainty analysis description"
                (change)="autoSave(dataAnalysisTechnology)"
              ></textarea>
            </div>
          </div>

          <div class="form-group">
            <label class="sub-header-drpdown pb-2">Excluded processes justification</label>
            <span
              placement="auto"
              class="textarea-tooltip"
              tooltipClass="sku-tooltip"
              ngbTooltip="Provide a justification for why certain processes if any. have been excluded from your product system."
            >
              <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
            /></span>
            <div class="services-form">
              <textarea
                formControlName="excludedProcessJusti"
                class="resizable-textarea"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                placeholder="Excluded processes justification"
                (change)="autoSave(dataAnalysisTechnology)"
              ></textarea>
            </div>
          </div>

          <div class="form-group">
            <label
              class="sub-header-drpdown pb-2"
              text="Justify any changes to the default recycling allocation settings."
              joyrideStep="adv-9"
              (next)="onNext('adv-9')"
              stepPosition="right"
              >Multi-functionality justification</label
            >
            <span
              placement="auto"
              class="textarea-tooltip"
              tooltipClass="sku-tooltip"
              ngbTooltip="Justify any changes to the default recycling rules."
            >
              <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
            /></span>
            <div class="services-form">
              <textarea
                formControlName="multiFunJustification"
                class="resizable-textarea"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                placeholder="Multi-functionality justification"
                (change)="autoSave(dataAnalysisTechnology)"
              ></textarea>
            </div>
          </div>

          <div class="form-group">
            <label class="sub-header-drpdown pb-2">Sensitivity analysis description</label>
            <div class="services-form">
              <textarea
                formControlName="sensitivityAnalysisDescription"
                class="resizable-textarea"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                placeholder="Sensitivity Analysis Description"
                (change)="autoSave(dataAnalysisTechnology)"
              ></textarea>
            </div>
          </div>
        </div>

        <div>
          <div class="d-flex align-items-center" id="dqa-grid">
            <span
              class="sensiHeading"
              joyrideStep="adv-10"
              stepPosition="right"
              (next)="onNext('adv-10')"
              text="Rank the input data in terms of fitness for purpose, and provide comments where required. Refer to the key below."
              >Data quality assessment</span
            >
            <a
              class="DQA-tooltip"
              tooltipClass="sku-tooltip"
              ngbTooltip="Conduct a data quality assessment all input data and ranked in terms of its fitness for purpose."
            >
              <img src="./assets/icons/grey-question-icon.svg" width="14" height="14" alt="" />
            </a>
          </div>
          <div
            id="divmanufactureofmaterialList"
            *ngrxLet="projectFacade.dataAnalysisTechnology$ as dataAnalysisTechnology"
          >
            <piqet-angular-portlet
              [columnDefs]="ISOColumnDef"
              [gridName]="'Data quality assessment'"
              [gridData]="dataAnalysisTechnology"
              [class]="'overflowCheck'"
              [isChekIniline]="true"
              [frameworkComponents]="frameworkComponents"
              [hidePagination]="true"
              [class]="'detail-cell-renderer'"
              [isInlineGrid]="true"
              [hideSearch]="true"
            ></piqet-angular-portlet>
          </div>
        </div>

        <div>
          <div class="d-flex align-items-center">
            <span class="sensiHeading mt-4">Key</span>
            <a
              class="key-tooltip"
              tooltipClass="sku-tooltip"
              ngbTooltip="Use the key to rank the data quality according to each category."
            >
              <img src="./assets/icons/grey-question-icon.svg" width="15" height="14" alt="" />
            </a>
          </div>
          <ul class="reviewUL">
            <li *ngFor="let item of reviewColorList; let i = index">
              <span
                class="circle"
                [style.background-color]="circleColors[i % circleColors.length]"
              ></span>
              <span class="text">{{ item }}</span>
            </li>
          </ul>
        </div>

        <div class="row mt-5 mb-2">
          <div id="interpretation-sect">
            <label
              class="sub-header-drpdown pb-2"
              joyrideStep="adv-12"
              stepPosition="right"
              (next)="onNext('adv-12')"
              text="Examine and interpret the results of your LCA."
              >Interpretation</label
            >
            <span
              class="tooltip-header"
              placement="auto"
              class="textarea-tooltip"
              tooltipClass="sku-tooltip"
              ngbTooltip="Examine and interpret the results of your LCA here."
            >
              <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
            /></span>
            <div class="services-form">
              <textarea
                class="resizable-textarea"
                formControlName="interpretationText"
                (change)="autoSave(dataAnalysisTechnology)"
                cols="20"
                id="conclusion"
                name="conclusion"
                rows="2"
                placeholder="Interpretation"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row mt-5 mb-2">
          <div id="concl-sect">
            <label
              joyrideStep="adv-13"
              stepPosition="top"
              (next)="onNext('adv-13')"
              text="Conclude the report with recommendations drawn from the findings. Additional comments can also be added here."
              class="sub-header-drpdown pb-2"
              >Recommendations and conclusions</label
            >
            <span
              class="tooltip-header"
              placement="auto"
              class="textarea-tooltip"
              tooltipClass="sku-tooltip"
              ngbTooltip="Conclude the report with recommendations drawn from the findings. Additional comments can also be added here."
            >
              <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
            /></span>
            <div class="services-form">
              <textarea
                formControlName="conclusion"
                cols="20"
                id="conclusion"
                name="conclusion"
                rows="2"
                class="resizable-textarea"
                placeholder="Recommendations and conclusions"
                (change)="autoSave(dataAnalysisTechnology)"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="setButtonAndError text-margin">
      <div class="modal-footer">
        <button
          (click)="onSave(dataAnalysisTechnology)"
          class="modelBtn purpleBtnHoverEffect"
          *ngIf="showEdit"
        >
          Save
        </button>
        <button type="button" (click)="nextPage(dataAnalysisTechnology)" class="next-btn modelBtn">
          Next <i class="bi bi-arrow-right checkbox-div"></i>
        </button>
      </div>
    </div>
  </div>
</div>
